import * as css from './Permissions.css';
import {useEffect, useState,Fragment} from 'react';
import SubPermission from '../subPermissions/SubPermission';
import PermissionsItemClub from '../permissionsItem/PermissionsItemClub';
import PermissionsItem from '../permissionsItem/PermissionsItem';
import {useSelector} from 'react-redux';
import useShow from '../../../../hooks/useShow';
import UpgradePopup, {permissionToCamelCase} from '../upgradePopup/UpgradePopup';
import {getAccountClubPermissions, getAccountPermissions} from '../../../../redux/account/accountActions';
import {DISPLAY_SUSPENDED_CONFIRMATION, IS_PRODUCTION} from '../../../../config/config';
import WhatsAppPricingPopup from '../../../../component/whatsappPricingPopup/WhatsAppPricingPopup';

const getCategories = (pid, clubs) => ({
    general:[ 'languageAdvanced', 'reserved', 'crmImport', 'smsEnter' ],
    advanced: ['publish', 'publishPixel','googleWalletTicket','publishEmbed','domain' ,'whatsApp', 'defaultWhatsApp', 'ticketValidity'],
    eventTypes:['ticket' ,'area', 'scheduled', 'timetable', 'course', 'cluster', 'undatedEvent', 'eventCash', 'home','hub','givechak', ...(IS_PRODUCTION ? [] : ['subscription'])],
    collection:[
        'billing','payments','consumerClubs',...clubs.map(club => club.clubName),'suspended',
        ...((DISPLAY_SUSPENDED_CONFIRMATION.includes(pid) ||!IS_PRODUCTION) ? ['customerConfirmation'] : []),
        'boxoffice','currency'
    ],    ordersCancellation:['userCancelTicket','defaultUserCancelTicket'],
    coupons: ['crowds','couponVoucher','externalVoucher' ],
});
const master= ['creditRefund','ticketsEmail','cancellationFee','ticketsBranding','packageCash', 'customPixel', 'promotionMessage', 'glatticketShow'];
// master:[ 'creditRefund','מזומן כברירת מחדל','דף חסום לקהל ','packageCrm','ticketsEmail','cancellationFee','ticketsBranding','packageCash' ]
function Permissions() {
    const permissions = useSelector(state => state.account.permissions);
    const getAccountClubPermissionsXHR = useSelector(state => state.account.getAccountClubPermissionsXHR);
    const [indexPopup, setIndexPopup] = useState(null);
    const clubs = useSelector(state => state.account.clubs);
    const isMasterState = useSelector(state => state.ui.isMasterState);
    const pid= useSelector(state => state.account.pid);
    const whatsappPricingShow = useShow();
    // const permissionConditions = {
    //     customerConfirmation: {
    //         requiredPermissions: ['suspended'],
    //         condition: (permissions) => {
    //             const suspended = permissions.find(p => permissionToCamelCase(p.permission) === 'suspended');
    //             return suspended?.status === 1;}
    //     },
    //     defaultUserCancelTicket: {
    //         requiredPermissions: ['userCancelTicket'],
    //         condition: (permissions) => {
    //             const suspended = permissions.find(p => permissionToCamelCase(p.permission) === 'userCancelTicket');
    //             return suspended?.status === 1;}
    //     }
    // };
    useEffect( () => {
        if(!permissions?.length)
            getAccountPermissions();
        if(getAccountClubPermissionsXHR !== 'SUCCESS') {
            getAccountClubPermissions().then();
        }
    }, []); 

    const {open, close, isOpen, showClass} = useShow();

    const openPopup = (index) => {
        const permission = permissions[index];
        if(permission.permission === 'whatsApp') {
            whatsappPricingShow.open();
        } else {
            setIndexPopup(index);
            open();
        }
    };
    
    const getDisabled = {
        defaultUserCancelTicket: () => {
            const userCancelTicketPermission = permissions.find(p => permissionToCamelCase(p.permission) === 'userCancelTicket');
            return userCancelTicketPermission && userCancelTicketPermission.status === 0;
        },
        defaultWhatsApp: () => {
            const whatsAppPermission = permissions.find(p => permissionToCamelCase(p.permission) === 'whatsapp');
            return whatsAppPermission && whatsAppPermission.status === 0;
        },
        customerConfirmation: () => {
            const userCancelTicketPermission = permissions.find(p => permissionToCamelCase(p.permission) === 'suspended');
            return userCancelTicketPermission && userCancelTicketPermission.status === 0;
        },
        default:false
    };
    
    const getPermissionItem=(permission)=>{
        const index = permissions?.findIndex((i) => permission ===permissionToCamelCase(i.permission));
        if(index!==-1) {
            return <PermissionsItem key={index} index={index} disabled={getDisabled[permission]?getDisabled[permission]():getDisabled.default} openPopup={openPopup} permission={permissionToCamelCase(permissions[index].permission)} />;
        } else if(clubs.some(club => club.clubName === permission)) {
            return <PermissionsItemClub key={permission} index={-1} openPopup={openPopup} permission={clubs.find(club => club.clubName === permission)} />;
        }
    };
   
    const isConsumerClubsActive = () => {
        const clubPerm = permissions.find(p => permissionToCamelCase(p.permission) === 'consumerClubs');
        return clubPerm && clubPerm.status === 1;
    };

    return (<>
        <css.container>
            {Object.entries(getCategories(pid, clubs)).map(([key,value]) =>
                <Fragment key={key}>
                    <SubPermission name={key} />
                    {value
                        .filter(permission =>
                            !(clubs.some(club => club.clubName === permission) && !isConsumerClubsActive() )
                        )
                        .map(permission => getPermissionItem(permission))
                    }
                    {/* {value.map(permission=>getPermissionItem(permission))} */}
                </Fragment>
            )}
                
            {isOpen && <UpgradePopup index={indexPopup} showClass={showClass} close={close} />}
            {whatsappPricingShow.isOpen && <WhatsAppPricingPopup show={whatsappPricingShow} isBottomPosition={true}/>}
        </css.container>
        { isMasterState&&
        <css.masterWrap>
            <SubPermission name='master' />
            <css.master>
                {master.map(permission=>getPermissionItem(permission))}
            </css.master>
        </css.masterWrap> }
    </>
    );
}

export default Permissions;
